module.exports = __webpack_public_path__ + "static/elco-metallic-fac140012acb536f824fa1205279b525.png";